import * as React from "react"
import { SVGProps, memo } from "react"

const HighQualityOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 58 36" fill="none" {...props}>
    <path
      d="M0 8.02v19.248c0 4.42 3.562 8.02 7.937 8.02h41.271c4.375 0 7.937-3.6 7.937-8.02V8.02c0-4.42-3.562-8.02-7.937-8.02H7.937C3.559 0 0 3.6 0 8.02zm49.205-4.813c2.626 0 4.764 2.16 4.764 4.813v19.248c0 2.654-2.138 4.813-4.764 4.813H7.937c-2.626 0-4.763-2.16-4.763-4.813V8.02c0-2.653 2.137-4.813 4.763-4.813h41.268z"
      fill="#000"
    />
    <path
      d="M14.913 24.831c.735 0 1.281-.567 1.281-1.302v-4.6h6.847v4.6c0 .735.672 1.302 1.428 1.302.735 0 1.303-.567 1.303-1.302v-11.93c0-.756-.567-1.302-1.303-1.302-.756 0-1.428.546-1.428 1.302v4.579h-6.847v-4.579c0-.756-.546-1.302-1.28-1.302-.946 0-1.492.546-1.492 1.302v11.93c0 .735.546 1.302 1.491 1.302z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.74 17.669c0-5.167-3.822-7.792-7.729-7.792-3.717 0-7.918 2.625-7.918 7.792s4.222 7.708 7.918 7.708c1.702 0 2.983-.357 4.075-1.113l.714.567c1.407 1.323 3.214-.735 1.827-1.995l-.336-.4c.945-1.302 1.45-2.772 1.45-4.767zm-5.838.357l2.373 2.373c.525-.735.756-1.638.756-2.73 0-3.34-2.625-5.04-5.02-5.04-2.583 0-5.124 1.7-5.124 5.04 0 2.541 2.163 4.957 5.124 4.957.756 0 1.492-.19 2.227-.378l-2.395-2.206c-1.113-1.344.651-3.255 2.059-2.016z"
      fill="#000"
    />
  </svg>
)

const MemoHighQualityOutlined = memo(HighQualityOutlined)
export default MemoHighQualityOutlined
